<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
      <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="1000px" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex>
                  <image-uploader
                    v-bind:constImage="local.image"
                    v-bind:dialog="dialog"
                    @image="assignImage">
                  </image-uploader>

                  <v-text-field
                    label="Media Name"
                    v-model="local.name"
                    :rules="generalRules"
                    required
                  >
                  </v-text-field>

                  <v-textarea
                    label="Description(Optional)"
                    v-model="local.description">
                  </v-textarea>
                  <v-text-field
                    v-model="local.duration"
                    label="Duration (sec)"
                    type="number">
                  </v-text-field>
                  <div v-if="local.typeOfMedia !== 'sound'">
                    <v-text-field
                      label="Media Height"
                      v-model="local.mediaHeight">
                    </v-text-field>
                    <v-text-field
                      label="Media Width"
                      v-model="local.mediaWidth">
                    </v-text-field>
                  </div>
                  <div v-else>
                    <v-select
                      :items="typeOfSound"
                      v-model="local.sound"
                      label="Select Sound Type"
                      chips
                      persistent-hint>
                    </v-select>
                    <v-text-field
                      label="Minimum Distance"
                      v-model="local.minimumDistance">
                    </v-text-field>
                    <v-text-field
                      label="Maximum Distance"
                      v-model="local.maximumDistance">
                    </v-text-field>
                    <v-text-field
                      label="Assigned Asset"
                      v-model="local.assignedAsset">
                    </v-text-field>
                  </div>
                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>

                <v-flex>
                  <div v-if="local.typeOfMedia === 'image'">
                    <v-select
                      :items = "typeOfImage"
                      label = "Type of Display"
                      v-model = "local.typeOfImage"
                      :rules="generalRules"
                      required
                    ></v-select>
                  </div>
                  <div>
                    <v-text-field
                      label="Layer"
                      v-model="local.layer">
                    </v-text-field>
                    <v-select
                      :items = "alignmentTypes"
                      label = "Alignment Type"
                      v-model = "local.alignmentType"
                      :rules="generalRules"
                      required
                    ></v-select>
                    <popover :always="true">
                      <h3>Position of Origin</h3>
                    </popover>
                    <v-layout>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.positionOfOrigin.X"
                          label="Dimension X"
                          type="number">
                        </v-text-field>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.positionOfOrigin.Y"
                          label="Dimension Y"
                          type="number">
                        </v-text-field>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.positionOfOrigin.Z"
                          label="Dimension Z"
                          type="number">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <popover :always="true">
                      <h3>Rotation of Origin</h3>
                    </popover>
                    <v-layout>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.rotationOfOrigin.X"
                          label="Dimension X"
                          type="number">
                        </v-text-field>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.rotationOfOrigin.Y"
                          label="Dimension Y"
                          type="number">
                        </v-text-field>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.rotationOfOrigin.Z"
                          label="Dimension Z"
                          type="number">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <popover :always="true">
                      <h3>Scale of Origin</h3>
                    </popover>
                    <v-layout>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.scaleOfOrigin.X"
                          label="Dimension X"
                          type="number">
                        </v-text-field>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.scaleOfOrigin.Y"
                          label="Dimension Y"
                          type="number">
                        </v-text-field>
                      </v-flex>
                      <v-spacer/>
                      <v-flex xs3>
                        <v-text-field
                          v-model="local.scaleOfOrigin.Z"
                          label="Dimension Z"
                          type="number">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-text-field
                      label="Offset Horizontal"
                      v-model="local.offsetHorizontal">
                    </v-text-field>
                    <v-text-field
                      label="Offset Vertical"
                      v-model="local.offsetVertical">
                    </v-text-field>
                  </div>
                </v-flex>

                <v-spacer></v-spacer>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn color="primary" v-if="showSaveButton"  @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ImageUploader from '../uploader/imageUploader'
import FileUploader from '../uploader/fileUploader'

export default {
  // name: 'addCharacterModel',
  name: 'addOverlay',
  components: { ImageUploader, FileUploader },
  data: () => ({
    valid: true,
    saving: false,
    generalRules: [
      v => !!v || 'This field is required'
    ],
    typeOfMedia: ['image', 'video', 'sound'],
    typeOfImage: ['2D', '3D'],
    alignmentTypes: ['Center', 'Left', 'Right', 'Top', 'Bottom'],
    typeOfSound: [],
    url: '',
    soundUrl: '',
    checkUrl: null,
    checkSoundUrl: null,
    displayTypes: [],
    local: {
      id: null,
      name: '',
      description: '',
      image: null,
      typeOfMedia: 'image',
      typeOfImage: '2D',
      videoLink: '',
      Media: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      duration: 0,
      mediaHeight: '',
      mediaWidth: '',
      layer: '',
      alignmentType: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      offsetHorizontal: '',
      offsetVertical: '',
      sound: '',
      minimumDistance: '',
      maximumDistance: '',
      assignedAsset: '',
      soundLink: '',
      mediaLength: ''
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    showSaveButton: true,
    info: {
      id: null,
      name: '',
      filename: '',
      service: '',
      description: '',
      image: null,
      duration: 0,
      typeOfDisplay: '',
      mediaHeight: '',
      mediaWidth: '',
      layer: '',
      alignmentType: '',
      soundLink: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      offsetHorizontal: '',
      offsetVertical: '',
      mediaLength: ''
    }
  },
  computed: {
    formTitle () {
      // return this.editedID === -1 ? 'New Character Model' : 'Edit Character Model'
      return this.editedID === -1 ? 'New Images' : this.showSaveButton ? 'Edit Images' : 'Preview Images'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
      }
    }
  },
  methods: {
    assignImage (val) {
      this.local.image = val
    },
    open () {
      this.$emit('open')
    },
    close () {
      // console.log(`image: ${this.local.image.imageURL}`)
      // console.log(`imageFile: ${this.local.image.imageFile}`)
      this.$emit('close')
    },
    addURL () {
      let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
      let objExp = new RegExp(Expression)
      if (objExp.test(this.url) === true) {
        this.checkUrl = true
        this.local.videoLink = this.url
        // this.url = ''
      } else {
        this.checkUrl = false
      }
    },
    addSoundURL () {
      let Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/
      let objExp = new RegExp(Expression)
      if (objExp.test(this.url) === true) {
        this.checkSoundUrl = true
        this.local.soundLink = this.soundUrl
        // this.url = ''
      } else {
        this.checkSoundUrl = false
      }
    },
    validateForm () {
      let flag = this.$refs.form.validate()
      if (this.local.image === null) {
        flag = false
        this.errorMsg = 'Please add a picture'
      }
      if (this.typeOfMedia === 'video') {
        if (this.local.Media === {} && this.local.videoLink === null) {
          flag = false
          this.errorMsg = 'Please add a video file or video link'
        }
      } else {
        if (this.local.Media === {}) {
          flag = false
          this.errorMsg = 'Please add a media file'
        }
      }
      return flag
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    },
    assignFile (payload) {
      this.local.UI = payload
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addOverlay.vue